var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.598 392.598",
    xmlSpace: "preserve",
    width: "82px",
    height: "82px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M77.446,247.079h237.705c30.707,0,55.661-24.954,55.661-55.661c0-28.509-21.333-52.234-49.584-55.273 c-6.723-0.646-11.184-7.37-9.503-13.188c0.905-4.073,1.422-8.145,1.422-12.154c0-30.707-24.954-55.661-55.661-55.661 c-4.073,0-8.339,0.517-12.606,1.487c-3.943,0.905-8.016-0.388-10.667-3.491c-17.39-19.846-42.408-31.289-68.719-31.289 c-46.352,4.331-91.41,31.741-90.44,103.952c0.129,5.236-3.491,9.891-8.663,10.99c-25.794,5.172-44.477,28.121-44.477,54.497 C21.786,222.061,46.739,247.079,77.446,247.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M318.836,157.867L318.836,157.867c-19.394-2.069-32.711-20.558-28.444-39.564v-0.065 c0.517-2.521,0.84-4.913,0.84-7.37c0-18.618-15.127-33.745-33.745-33.745c-2.457,0-4.913,0.323-7.628,0.905l-19.071,4.396 l-12.929-14.739c-13.188-15.127-32.323-23.855-52.234-23.855c-20.945,0-39.693,9.374-52.493,24.048h29.867 c6.141,0,11.313,4.978,11.184,11.119c-0.129,5.947-4.913,10.667-10.925,10.667h-42.731c-0.065,0-0.065,0-0.129,0 c-2.715,7.434-4.267,15.321-4.267,23.661c0,0.517,0.065,1.228,0.065,1.745h25.341c6.141,0,11.313,4.978,11.184,11.119 c-0.129,5.947-4.913,10.667-10.925,10.667H98.521l0,0c1.099,8.663-4.655,16.743-13.253,18.489l-14.739,2.974 c-16.226,3.297-27.863,18.036-27.022,34.844c0.905,18.036,16.162,32.065,34.263,32.065h237.188 c18.618,0,33.745-15.127,33.745-33.745C348.962,174.093,335.968,159.677,318.836,157.867z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 310.174,
    y: 309.85,
    style: {
      fill: "#FFC10D"
    },
    width: 60.509,
    height: 60.509
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.855,
    y: 309.85,
    style: {
      fill: "#FFC10D"
    },
    width: 60.509,
    height: 60.509
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M381.673,288.065h-82.424c-6.012,0-10.925,4.848-10.925,10.925v36.202h-21.527v-66.327h48.291 c42.667,0,77.446-34.715,77.446-77.446c0-35.879-24.242-66.327-57.923-74.925c0.129-1.875,0.259-3.814,0.259-5.624 c0-42.667-34.715-77.446-77.446-77.446c-3.685,0-7.434,0.323-11.184,0.84C224.97,12.606,195.943,0.259,165.495,0.259 c-62.384,0-113.842,47.903-113.002,117.915C21.527,128.646,0,158.125,0,191.483c0,42.667,34.715,77.382,77.446,77.382h50.36v56.178 h-21.527V298.99c0-6.012-4.848-10.925-10.925-10.925H12.929c-6.012,0-10.925,4.848-10.925,10.925v82.36 c0,6.012,4.848,10.925,10.925,10.925h82.36c6.012,0,10.925-4.848,10.925-10.925v-34.457h32.453c6.012,0,10.925-4.848,10.925-10.925 v-67.103h95.418v77.253c0,6.012,4.848,10.925,10.925,10.925h32.453v24.372c0,6.012,4.848,10.925,10.925,10.925h82.36 c6.012,0,10.925-4.849,10.925-10.925V298.99C392.533,292.978,387.685,288.065,381.673,288.065z M84.364,370.36H23.855v-60.509 h60.509V370.36z M77.446,247.208c-30.707,0-55.661-24.954-55.661-55.661c0-26.505,18.747-49.39,44.477-54.626 c5.236-1.099,8.792-5.689,8.663-10.99C74.02,53.786,118.949,26.311,165.43,21.98c26.246,0,51.329,11.442,68.719,31.289 c2.651,3.038,6.788,4.331,10.667,3.491c4.267-1.034,8.469-1.487,12.606-1.487c30.707,0,55.661,24.954,55.661,55.661 c0,3.943-0.453,8.016-1.422,12.154c-1.681,5.883,2.715,12.606,9.503,13.188c28.25,3.038,49.584,26.828,49.584,55.273 c0,30.707-24.953,55.661-55.661,55.661L77.446,247.208L77.446,247.208z M370.747,370.36h-60.509v-60.509h60.509V370.36z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.5ec2752e958471c2e23cfc9bc39ec14f.svg";
export { ForwardRef as ReactComponent };